import { type ChangeEvent, useState } from 'react';
import TextArea from '../../../../../juristec-ui/core/TextArea';
import ActionsGroup from '../../../../../juristec-ui/core/ActionsGroup';
import Button from '../../../../../juristec-ui/core/Button';
import AssistentTokensBadge, { type GptTokens } from '../../../../AssistentTokensBadge/AssistentTokensBadge';
import {
  MainContainer, InputWrapper, GPTCredits, InstructionsWrapper, Info,
} from './styled';
import { trimString } from '../../../../../juristec-ui/utils/functions/formatString';
import { Add, Minus } from '../../../../../juristec-ui/icons';

interface AssistantSugestionProps {
  submitQuestion: (question: string) => void;
  hide: () => void;
  gptTokens: GptTokens;
}

const AssistantSugestion = ({
  submitQuestion, hide, gptTokens,
}: AssistantSugestionProps) => {
  const [question, setQuestion] = useState<string>('');
  const [showQuestion, setShowQuestion] = useState<boolean>(false);

  const handleQuestion = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const val = e.target.value;
    setQuestion(val);
  };

  const handleBlurQuestion = () => {
    setQuestion(trimString(question));
  };

  const handleSubmit = () => {
    submitQuestion(showQuestion ? question : 'Be creative');
  };

  // const handleEmptySubmit = () => {
  //   submitQuestion('Be creative');
  // };

  const ToggleShowQuestion = () => {
    setShowQuestion((q) => !q);
  };

  return (
    <MainContainer>
      <span style={{ fontSize: '14px', marginBottom: '2px' }}>
        Utilize o assistente para sugerir KPI&apos;s relacionados a base de dados selecionada.
      </span>
      <Info>
        <b>Obs: </b>
        Este assistente realiza associações entre as colunas da base de dados selecionada.
        Ele não pode criar ou modificar os dados.
      </Info>
      <InputWrapper style={{ gridTemplateColumns: '1fr auto', marginBottom: '0' }}>
        <span style={{ marginRight: 'auto', fontSize: '12px' }}>
          *1 token por sugestão válida
        </span>
        <AssistentTokensBadge
          gptTokens={gptTokens}
        />
      </InputWrapper>
      <InputWrapper onClick={ToggleShowQuestion}>
        <Button
          style={{
            maxWidth: '300px',
            margin: '0 auto',
            padding: '2px 8px 2px 4px',
          }}
          variant="pattern"
          size="small"
          textTransform="none"
        >
          {showQuestion ? <Minus /> : <Add />}
          Adicionar instruções extras
        </Button>
      </InputWrapper>
      <InstructionsWrapper style={showQuestion ? {} : { display: 'none' }}>
        <TextArea
          // @ts-expect-error not typed yet
          // label="Orientação para o Assistente"
          value={question}
          onChange={handleQuestion}
          onBlur={handleBlurQuestion}
          placeholder="Ex.: Gere indicadores fiscais..."
          style={{ fontSize: '14px' }}
        />
      </InstructionsWrapper>
      <InputWrapper style={{ gridTemplateColumns: 'auto 1fr auto' }}>
        <GPTCredits style={{ display: 'block' }}>
          <span>
            Alimentado pelo
            {' '}
          </span>
          <a
            href="https://openai.com/pt-BR/index/gpt-4o-mini-advancing-cost-efficient-intelligence/"
            target="_blank"
            rel="noreferrer noopener"
          >
            GPT-4o mini
          </a>
        </GPTCredits>
      </InputWrapper>
      <ActionsGroup>
        <Button
          style={{ margin: '5px' }}
          onClick={hide}
          variant="outlined"
          size="large"
        >
          Cancelar
        </Button>
        {/* <Tooltip
          text="Deixe a Inteligência Artificial surpreendê-lo com sugestões criativas de KPIs para o seu dashboard!"
          direction="top"
          atModal
        >
          <Button
            style={{ margin: '5px' }}
            size="large"
            onClick={handleEmptySubmit}
            disabled={gptTokens.used >= gptTokens.limit && gptTokens.bonus <= 0}
          >
            Surpreenda-me
          </Button>
        </Tooltip> */}
        <Button
          style={{ margin: '5px' }}
          size="large"
          onClick={handleSubmit}
          disabled={(
            gptTokens.used >= gptTokens.limit && gptTokens.bonus <= 0
          ) || !(
            !showQuestion || (showQuestion && question.length > 0)
          )}
          textTransform="none"
        >
          {showQuestion ? 'Gerar com instruções' : 'Gerar'}
        </Button>
      </ActionsGroup>
    </MainContainer>
  );
};

export default AssistantSugestion;
